import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const DEFAULT_API_BASE = 'https://freebets-finder-matcher.kaxtest.workers.dev';

function mount(target: HTMLElement) {
  const apiBase = target.dataset.apiBase ?? DEFAULT_API_BASE;
  const variant = (target.dataset.variant === 'sidebar' ? 'sidebar' : 'default');
  const root = createRoot(target);
  root.render(
    <StrictMode>
      <App apiBase={apiBase} variant={variant} />
    </StrictMode>
  );
}

function init() {
  const targets = document.querySelectorAll<HTMLElement>('[id="freebets-finder"], .freebets-finder');
  targets.forEach(mount);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Expose for manual mounting in headless setups.
(window as unknown as { FreebetsFinder?: { mount: typeof mount } }).FreebetsFinder = {
  mount,
};
